import axios from "axios";
import { API_URL } from "config/constants";
import { store } from "store/store";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // API_URL, --- IGNORE ---
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState(); // Get the current state
    const token = state.auth.token;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
